// extracted by mini-css-extract-plugin
export var container = "OnePercentForThePlanet-module__container___Ww2Wm";
export var logo = "OnePercentForThePlanet-module__logo____Xp7R";
export var text = "OnePercentForThePlanet-module__text___ggVgF";